import cloneDeep from 'lodash/cloneDeep';
import { MODULE_BAIL, MODULE_ACHAT } from '@/configuration/devisConf';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';

export default function validation(response, messages, module, isAvoir = false) {
  if (!response.data.error?.validationErrors) return;
  let i18nType = '';
  switch (module) {
    case MODULE_BAIL:
      i18nType = 'editionCreationDepenseBailleur';
      break;
    case MODULE_TLPE:
      i18nType = 'editionTitreRecette';
      break;
    case MODULE_ACHAT:
      i18nType = 'addEditFactureAchat';
      break;
    default:
      i18nType = '';
      break;
  }
  if (isAvoir) {
    i18nType += '.avoir';
  }
  response.data.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (errorMessage.indexOf('LEAST_ONE_PRODUCT') === 0) {
      messages.push({
        message: i18nType + '.messages.error.leastOneProduct',
      });
    }
    if (errorMessage.indexOf('LEAST_ONE_CUSTOMER') === 0) {
      messages.push({
        message: i18nType + '.messages.error.leastOneBailleur',
      });
    }
    if (errorMessage.indexOf('TOTAL_HT_LOWER_THAN_DISCOUNT_LINE') === 0) {
      messages.push({
        message: i18nType + '.messages.error.TotalHtLowerThanDiscountLine',
      });
    }
    if (errorMessage.indexOf('REGULATION_MODE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.messages.error.regulationModeRequired',
      });
    }
    if (errorMessage.indexOf('SETTLEMENT_PERIOD_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.messages.error.settlementPeriodRequired',
      });
    }
    if (errorMessage.indexOf('PAYMENT_PLAN_DIFFERENT') === 0) {
      messages.push({
        message: i18nType + '.messages.error.paymentDifferent',
      });
    }
    if (errorMessage.indexOf('QUANTITY_LESS_ZERO') === 0) {
      messages.push({
        message: i18nType + '.messages.error.quantityLessZero',
      });
    }
    if (errorMessage.indexOf('SUM_OF_AMOUNTS_EXCEEDS_BILLS_AMOUNT') === 0) {
      messages.push({
        message: i18nType + '.messages.error.sumOfAmountExceedsBillsAmount',
      });
    }
    if (errorMessage.indexOf('ORDER_SHOULD_BE_RECONCILABLE') === 0) {
      const msgSplit = cloneDeep(errorMessage).split('|');
      const messageInformation = msgSplit[0].split('@');
      messages.push({
        message: i18nType + '.messages.error.orderShouldBeReconciliable',
        parametres: {
          commandeAchat: messageInformation[1],
        },
      });
    }
    if (errorMessage.indexOf('BILL_SHOULD_BE_RECONCILABLE') === 0) {
      messages.push({
        message: i18nType + '.messages.error.orderShouldBeReconciliable',
      });
    }
    if (errorMessage.indexOf('AMOUNT_TOO_HIGH') === 0) {
      const msgSplit = cloneDeep(errorMessage).split('|');
      const messageInformation = msgSplit[0].split('@');
      messages.push({
        message: i18nType + '.messages.error.amountTooHight',
        parametres: {
          commandeAchat: messageInformation[1],
          maxAmount: messageInformation[2],
        },
      });
    }
    if (errorMessage.indexOf('Commande_FullyReconciled') === 0) {
      const msgSplit = cloneDeep(errorMessage).split('|');
      const messageInformation = msgSplit[0].split('@');
      messages.push({
        message: i18nType + '.messages.error.commandeFullyReconciled',
        parametres: {
          commandeAchat: messageInformation[1],
        },
      });
    }
    if (errorMessage.indexOf('RECONCILIATION_DIFFERENT_PROVIDERS') === 0) {
      messages.push({
        message: i18nType + '.messages.error.reconciliationDifferentProviders',
      });
    }
    if (errorMessage.indexOf('STATE_DRAFT_REQUIRED_TO_DELETE') === 0) {
      const params = errorMessage.split('|')[0].split('@');
      messages.push({
        message: i18nType + 'editionCreationFactureAchat.messages.error.draftToDelete',
        parametres: {
          depenseBailleur: params[1],
        },
      });
    }
    if (errorMessage.indexOf('PRODUCT_TYPE_INVALIDE') === 0) {
      messages.push({
        message: i18nType + '.messages.error.productTypeInvalide',
      });
    }
    if (errorMessage.indexOf('PRODUCT_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.messages.error.productRequired',
      });
    }
    if (errorMessage.indexOf('ORDER_SAVED_STATE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.messages.error.echeanceEnregistreForRapprochement',
      });
    }
    if (errorMessage.indexOf('SAVED_PARTIALLY_BILLED_STATE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + '.messages.error.echeanceEnregistreFacturePartiellementForRapprochement',
      });
    }
    if (errorMessage.indexOf('FORBIDDEN_ON_AVOIR_RAPPROCHEMENT') === 0) {
      messages.push({
        message: 'detailDepenseBailleur.popUpAvoir.error.rapprochee',
      });
    }
    if (errorMessage.indexOf('POSITIVE_NORMAL_COMMAND_LINE_FORBIDDEN') === 0) {
      messages.push({
        message: i18nType + '.messages.error.positiveNormalCommandLineForbidden',
      });
    }
    if (errorMessage.indexOf('AMOUNT_INCORRECT') === 0) {
      messages.push({
        message: i18nType + '.messages.error.amountIncorrect',
      });
    }
  });
}
